module.exports = __webpack_public_path__ + "img/pbtm5.be32491c.png";